import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";
import { CA } from "../constants";
import { burstConfetti } from "./confetti";

export const CopyCA = ({ testId = "copy-ca-button", compact = false }) => {
  const [copied, setCopied] = useState(false);

  const copy = async (e) => {
    try {
      await navigator.clipboard.writeText(CA);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = CA;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      ta.remove();
    }
    burstConfetti(e.clientX, e.clientY);
    setCopied(true);
    toast.success("CA copied. Now don't fade it.", { duration: 2500 });
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <button
      onClick={copy}
      data-testid={testId}
      className="ca-pill rounded-full px-4 py-2.5 flex items-center gap-3 max-w-full"
      title="Copy contract address"
    >
      <span className="font-bebas tracking-widest text-[#14F195] text-sm shrink-0">CA</span>
      <span className={`font-mono text-zinc-300 truncate ${compact ? "text-xs" : "text-xs sm:text-sm"}`}>
        {CA}
      </span>
      {copied ? (
        <Check size={16} className="text-[#14F195] shrink-0" />
      ) : (
        <Copy size={16} className="text-zinc-400 shrink-0" />
      )}
    </button>
  );
};
